<template>
  <div>
    <v-currency-field
      :class="compClass"
      :label="label"
      :placeholder="placeholder"
      :type="type"
      :disabled="disabled"
      :readonly="readonly"
      v-model="elValue"
      @blur="onBlur"
      @focus="onFocus"
      @paste="onPaste"
      :prefix="null"
      :sufix="null"
      :default-value="defaultValue"
      :currency="null"
      locale="lt"
      :hide-details="hideDetails"
      :valueRange="valueRange"
      :decimal-length="precision"
      :allow-negative="allowNegative"
      :auto-decimal-mode="false"
      :maxlength="maxSymbols"
      v-validate="validateRules"
      :data-vv-name="validateName"
      :error-messages="errorMessages"
      :data-vv-validate-on="required || counter ? 'input' : 'change'"
      :autofocus="autofocus"
    >
      <el-tooltip slot="append" v-if="tooltip" :tooltip="tooltip" absolute />
      <template slot="append-outer">
        <slot name="append-outer"></slot>
      </template>
    </v-currency-field>
  </div>
</template>

<script>
export default {
  name: 'ElMoneyField',
  props: {
    classP: String,
    label: String,
    placeholder: { type: String, default: '0,00' },
    valueRange: { type: Object, default: null },
    precision: { type: Number, default: 2 },
    defaultValue: { type: Number, default: null },
    allowNegative: { type: Boolean, default: true },
    type: String,
    tooltip: String,
    hideDetails: [Boolean, String],
    required: Boolean,
    need: Boolean,
    validateKey: String,
    counter: { type: [Number, String], default: 14 },
    value: [String, Number],
    disabled: Boolean,
    readonly: { type: Boolean, default: false },
    autofocus: { type: Boolean, default: false },
  },
  data() {
    return {
      elValue: this.fixFormat(this.value),
    }
  },
  inject: {
    $validator: '$validator',
  },
  watch: {
    value(val) {
      if (val !== this.elValue) {
        this.elValue = val.toString().replace(',', '.')
      }
    },
    elValue(val) {
      this.$emit('input', val)
    },
  },
  computed: {
    validateName() {
      return this.validateKey ?? this.label
    },
    validateMessages() {
      return {
        'field may not be greater than': this.$t(
          'Viršytas simbolių skaičius {counter},{precision}',
          { counter: this.counter, precision: this.precision }
        ),
        'field is required': this.$t('Laukas privalomas'),
      }
    },
    validateRules() {
      let rule = ''
      rule = this.required ? 'required' : ''
      rule += this.counter ? (rule ? '|' : '') + `max:${this.maxLength}` : ''
      return rule
    },
    errorMessages() {
      const messages = this.errors.collect(this.label)
      if (messages.length > 0) {
        const key = Object.keys(this.validateMessages).find(item =>
          messages[0].includes(item)
        )
        return this.validateMessages[key]
      } else {
        return ''
      }
    },
    maxLength() {
      let max = this.counter
      if (this.elValue && this.elValue.toString().includes('.')) {
        max += this.elValue.toString().split('.')[1].length + 1
      }
      return max
    },
    maxSymbols() {
      return 14
    },
    requiredClass() {
      return (this.required || this.need) && !this.readonly
        ? 'required-input'
        : ''
    },
    compClass() {
      return `${this.classP} ${this.requiredClass} labelPatch`
    },
  },
  methods: {
    onBlur(e) {
      this.$emit('blur', this.elValue)
    },
    onFocus(e) {
      this.$emit('focus', this.elValue)
    },
    onPaste(e) {
      const clip = e.clipboardData.getData('text/plain')
      this.elValue = clip
        .toString()
        .replace(',', '.')
        .replaceAll(' ', '')
      e.preventDefault()
    },
    fixFormat(value) {
      if (!value) {
        return null
      }
      return value.toString().replace('.', ',')
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
